// import React from "react";
// import styled, { css } from "styled-components";
// import { useMobile } from "../utils/hooks/useMobile";

import { OwcTypography } from "@one/react/Components/OwcTypography";
import styles from "./WelcomeScreen.module.scss";

const WelcomeScreen = ({ text = "You must login to view applications." }) => {
  // const isMobile = useMobile();
  return (
    <div className={styles.welcomeScreenWrapper} data-testid="main-page-not-authenticated-with-no-error-by-backend">
      <OwcTypography style={{ color: "inherit" }} variant="title2">
        Digital Lab
      </OwcTypography>
      <OwcTypography style={{ color: "inherit" }} variant="title2">
        Welcome
      </OwcTypography>
      <div className={styles.wrapTitle5}>
        <OwcTypography style={{ color: "inherit" }} variant="title5">
          {text}
        </OwcTypography>
      </div>
    </div>
  );
};

export default WelcomeScreen;
